import React, { useEffect, useRef} from "react";
import BranchPinItem from "@Components/BranchPinItem";

const Map = ({ lat, long, zoom, branchesPins, apiKey }) => {
  const mapRef = useRef()

  useEffect(() => {

    if (!mapRef.current) {
      return
    }
    const { Maps: Lib } = require('@ffw/randstad-local-orbit/js/components/maps');
    new Lib(mapRef.current)

  }, [branchesPins])
  return (
    <div
      className="map"
      data-rs-maps={`${lat},${long}`}
      data-rs-maps-zoom={zoom}
      data-rs-maps-google-maps-key={apiKey}
      data-rs-maps-marker-url="/branches/assets/image/icons/marker.png"
      data-rs-maps-cluster={true}
      data-rs-maps-cluster-marker-url="/branches/assets/image/icons/cluster"
      ref={mapRef}
    >
      <ul className="popup-bubbles hidden">
        {branchesPins.map((item, i) => (
          <BranchPinItem branchData={item} key={i} />
        ))}
      </ul>
      <div data-rs-maps-placeholder="" className="map__gmaps"></div>
    </div>
  );
};

export default Map;
